import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { startChangeStateFacturacion, startloadSolFacturacion } from '../../../../app/store/reportes/thunks';
import Swal from 'sweetalert2';
import { Eye, Repeat } from 'react-feather';
import { connectionFiles } from '../../../../app/filesConnection';
import { SearchFacturacion } from '../../orderClose/modals/SearchFacturacion';
import { asignedID } from '../../../../app/store/facturacion/thunks';
import { Table } from '../../Table';


export const ListPending = () => {

    const { isLoading, status_report, facturacion } = useSelector(state => state.reportes);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(startloadSolFacturacion())
    }, []);

    // console.log(facturacion);


    const refreshData = () => {
        dispatch(startloadSolFacturacion())
    }

    const handleChangeState = (e, row) => {

        let tipo = row.FOLIO.includes('HDLV') == true ? 2 : 1;
        let folio = row.FOLIO;
        let estado = e.target.value;

        Swal.fire({
            title: 'Atención',
            text: "Está por cambiar de Estado a la Solicitud de Facturación, ¿Desea de continuar con esta acción?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b7ddd',
            cancelButtonColor: '#dc3545',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(startChangeStateFacturacion(tipo, folio, estado));
            } else {
                dispatch(startloadSolFacturacion());
            }
        })
    }

    const handledAsignarFacturacion = (id) => {
        dispatch(asignedID(id))
    }


    const columnsProducts = [

        {
            header: 'FOLIO',
            dataIndex: 'FOLIO',
            classHeader: 'text-start',
            classRow: 'text-start',
            renderer: (value) => {
                const url = value.includes('HDLV')
                    ? `./assets/reports/ordenVenta.html?folio=${value}`
                    : `./assets/reports/ordenEntrega.html?folio=${value}`;

                return (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link border-0"
                    >
                        {value}
                    </a>
                );
            },
        },
        {
            header: 'FECHA SOL.',
            dataIndex: 'FECHA',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'FECHA CERRADA',
            dataIndex: 'FECHA_CERRADA',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'CLIENTE',
            dataIndex: 'CLIENTE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'DATOS FACTURACIÓN',
            dataIndex: 'RAZON_SOCIAL',
            classHeader: 'text-start',
            classRow: 'text-start',
            renderer: (value, row) => {
                const sinDatos = !row.RAZON_SOCIAL;

                if (sinDatos) {
                    return (
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => handledAsignarFacturacion(row.FOLIO)}
                                data-bs-toggle="modal"
                                data-bs-target="#searchFacturacion"
                            >
                                Asignar
                            </button>

                            <span className="fw-bold text-danger">
                                No se han asignado datos de facturación
                            </span>
                        </div>
                    );
                }

                return (
                    <div className="text-wrap">
                        <div>
                            <strong>Razón social:</strong> {row.RAZON_SOCIAL}
                        </div>
                        <div>
                            <strong>Régimen:</strong> {row.REGIMEN_FISCAL}
                        </div>
                        <div>
                            <strong>Soc. mercantil:</strong> {row.SOCIEDAD_MERCANTIL}
                        </div>
                        <div>
                            <strong>Email:</strong> {row.CORREO}
                        </div>
                        <div>
                            <strong>Dirección:</strong> {row.DIRECCION}, CP: {row.COD_POSTAL}
                        </div>
                        <div>
                            <strong>Teléfono:</strong> {row.TELEFONO}
                        </div>
                    </div>
                );
            },
        },
        {
            header: 'CSF',
            dataIndex: 'CSF',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                if (!value) {
                    return <span className="text-muted">No registrado</span>;
                }

                return (
                    <a
                        href={`${connectionFiles['csfURL']}/${value}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-dark border-0"
                        title="Ver constancia de situación fiscal"
                    >
                        <Eye size={20} />
                    </a>
                );
            },
        },
        {
            header: 'ACCIONES',
            dataIndex: 'FOLIO',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <select
                    className="form-select"
                    defaultValue={0}
                    onChange={(e) => handleChangeState(e, row)}
                    disabled={!row.RAZON_SOCIAL}
                    style={{ minWidth: '130px' }}
                >
                    <option value={0}>Pendiente</option>
                    <option value={1}>Realizado</option>
                </select>
            ),
        },
    ];

    const data = [...facturacion];

    if (isLoading) {
        return (
            <>
                <div className='div_center'>
                    <div className='text-center'>
                        <div className="spinner"></div>
                    </div>
                    <div className='text-center text-left-15'>
                        <span className='fw-bold'>Cargando</span>
                    </div>
                    <div className='text-center text-left-15'>
                        <div className="spinner"></div>
                    </div>
                </div>
            </>
        )
    }


    return (
        <>
            <SearchFacturacion opc={1} />
            <div className="row">
                <div className="col-12">
                    <div className="card-body">
                        <button type="button" className="btn btn-outline-dark" onClick={refreshData}>
                            <Repeat size='16' />   Cargar datos
                        </button>
                        <div className='col-12 mt-3'>
                            <Table
                                columns={columnsProducts}
                                data={data}
                                function_={(row) => { console.log(row); }}
                                placeholderSearch="Buscar por: Orden de servicio"
                                showPagination={true}
                                showControls={true}
                                showTotals={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
